import { Box, Text, VStack } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import useAbilityPermissions from "../../hooks/useAbilityPermissions";
import { navLinks } from "../../store/constants";

/**
 * Maps reportRange name to RBAC resource key.
 */
const RANGE_RESOURCE_MAP = {
  year: "qm.reports",
  month: "qm.reports",
  week: "qm.reports",
  day: "qm.reports",
  realtime: "qm.reports.realtime",
  ticket_info: "qm.reports.export",
};

function Nav() {
  const { reportRange } = useSelector((state) => state.defaultReducer);
  const { can } = useAbilityPermissions();

  const resource = RANGE_RESOURCE_MAP[reportRange] || "qm.reports";

  if (!can("read", resource)) {
    return null;
  }

  return (
    <Box className="navigation">
      <VStack gap={4} align="stretch" pt={0}>
        {navLinks
          .find((a) => a.name === reportRange)
          ?.links.map((a, i) => {
            return (
              <Box key={i} mt="10px">
                <Text fontSize="14px" fontWeight="400" color="var(--gray-8)">
                  {a.name}
                </Text>
                <VStack gap={2} align="stretch" pt={2}>
                  {a.links.map((b, j) => {
                    return (
                      <NavLink
                        color="#fff"
                        key={j}
                        to={b.link}
                      >
                        {b.name}
                      </NavLink>
                    );
                  })}
                </VStack>
              </Box>
            );
          })}
      </VStack>
    </Box>
  );
}

export default Nav;
